// Fonction pour convertir une couleur hexadécimale en objet RGB
function hexToRgb(hex) {
    // Supprimer le signe #
    hex = hex.replace(/^#/, '');

    // Si le format est court (3 caractères), le convertir en format long (6 caractères)
    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    // Extraire les valeurs RGB
    let bigint = parseInt(hex, 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;

    return {r, g, b};
}

// Fonction pour calculer la luminosité relative
function relativeLuminance({r, g, b}) {
    let [R, G, B] = [r, g, b].map(v => {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}

// Fonction pour ajuster la luminosité d'une couleur
export function adjustColor(hexColor, factor) {
    let {r, g, b} = hexToRgb(hexColor);
    r = Math.min(255, Math.max(0, r + factor * 255));
    g = Math.min(255, Math.max(0, g + factor * 255));
    b = Math.min(255, Math.max(0, b + factor * 255));
    return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1, 7)}`;
}

// Fonction pour ajuster l'opacité d'une couleur
export function opacifyColor(hexColor, factor) {
    let {r, g, b} = hexToRgb(hexColor);
    return `rgba(${r}, ${g}, ${b}, ${factor})`;
}

function colorDistance(color1, color2) {
    let rDiff = color1.r - color2.r;
    let gDiff = color1.g - color2.g;
    let bDiff = color1.b - color2.b;
    return Math.sqrt(rDiff * rDiff + gDiff * gDiff + bDiff * bDiff);
}

export function isColorClose(inputColor, targetColor, threshold = 50) {
    const targetRgb = hexToRgb(targetColor);
    const inputRgb = hexToRgb(inputColor);
    const distance = colorDistance(inputRgb, targetRgb);
    return distance < threshold;
}

// Fonction principale pour obtenir une couleur avec un meilleur contraste
export function getContrastingColor(color, backgroundColor) {
    let rgbColor = hexToRgb(color);
    let rgbBackground = hexToRgb(backgroundColor);

    let luminanceColor = relativeLuminance(rgbColor);
    let luminanceBackground = relativeLuminance(rgbBackground);

    // Si la couleur est plus claire que le fond, la rendre plus foncée, et vice versa
    let factor = luminanceColor > luminanceBackground ? -0.5 : 0.5;
    return adjustColor(color, factor);
}
